const jobSlotModule = {
  namespaced: true,
  state: {
    jobSlots: [],
  },
};

export default jobSlotModule;
